import React, { useState } from "react";
import { Button, Col, Form, Modal, Row, Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { getProviderListCode } from "../../../../store/SendMessageSlice";
import SVGIcon from "../../../../utils/SVGIcon";
import dayjs, { Dayjs } from "dayjs";
import { CONSTANT } from "../../../../config/Constant";
import { addInternalReport } from "../../../../store/InternalReportSlice";

const AddReport: React.FC<any> = (props) => {
  const { handleAddModal, openAddModal, getList } = props;

  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState<boolean>(false);
  const [typeAction, setTypeAction] = useState<string>("daily");
  const [providerListCode, setProviderListCode] = useState<any>();
  const [monthReq, setMonthReq] = useState(false);

  const updateProviderListCode = () => {
    dispatch(getProviderListCode())
      .then((res: any) => {
        const listOfProviders = res?.data
          .filter((item) => item?.id)
          .reduce((acc, current) => {
            const x = acc.find((item) => item.id === current.id);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, []);
        listOfProviders && setProviderListCode(listOfProviders);
      })
      .catch((error: any) => {
        setProviderListCode([]);
      });
  };

  const handleSubmit = (data) => {
    setLoading(true);
    let report_year: string = '';
    let report_date: string = '';
    if (data?.report_year) {
      report_year = dayjs(data?.report_year).format("YYYY");
    }
    if (data?.type !== "yearly") {
      report_date = data?.report_date
        ? dayjs(data?.report_date).format("YYYY-MM-DD")
        : dayjs(new Date()).format("YYYY-MM-DD");
    }

    const payload = {
      type: data?.type,
      provider: data?.provider ?? "",
      report_date: report_date ?? "",
      report_year: report_year ?? "",
    };

    dispatch(addInternalReport(payload))
      .then((res: any) => {
        handleAddModal();
        getList();
      })
      .catch((error: any) => {
        console.log("error", error);

        // handleAddModal();
        // getList();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  const disabledDate = (current: Dayjs) => {
    // Can not select days after today
    return current && current.isAfter(dayjs().endOf("day"));
  };

  const disabledDateForYear = (current: Dayjs) => {
    // Disable years before 2022 and years after the current year
    const currentYear = dayjs().year();
    return current && (current.year() < 2022 || current.year() > currentYear);
  };

  return (
    <Modal
      open={openAddModal}
      destroyOnClose
      width={900}
      onCancel={handleAddModal}
      closeIcon={<FontAwesomeIcon icon={faTimes} />}
      footer={false}
      className="addModal"
      title={`Add Internal Report`}
    >
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onBlur", "onInput"]}
        autoComplete="off"
      >
        <Row gutter={20} align={"middle"}>
          <Col xs={24}>
            <InputBox.Radio
              type="button"
              label="Type"
              name={"type"}
              size="large"
              initialValue={typeAction}
              options={{
                list: [
                  { label: "Daily", value: "daily" },
                  { label: "Weekly", value: "weekly" },
                  { label: "Monthly", value: "monthly" },
                  { label: "Quarterly", value: "quartely" },
                  { label: "Yearly", value: "yearly" },
                ],
                valueKey: "value",
                textKey: "label",
              }}
              onChange={(e: any) => {
                setTypeAction(e.target.value);
                if (e.target.value === "monthly" && form.getFieldValue("provider")) {
                  setMonthReq(true);
                  form.setFields([
                    {
                      name: "month",
                      errors: ["Please Select Month"],
                    },
                  ]);
                }
              }}
            />
          </Col>
          {typeAction === "daily" ? (
            <Col xs={24} md={8}>
              <InputBox.DatePicker
                required
                label="Select Date"
                name={"report_date"}
                placeholder={"Select Date"}
                format={CONSTANT.POST_DATE_FORMAT}
                disabledDate={disabledDate}
                defaultValue={dayjs(new Date())}
                initialValue={dayjs(new Date())}
                onChange={handleChange}
                rules={[{ required: true, message: "Please Select Date." }]}
              />
            </Col>
          ) : null}
          {typeAction === "monthly" ? (
            <Col xs={24} md={8}>
              <InputBox.DatePicker
                required
                label="Select Date"
                name={"report_date"}
                placeholder={"Select Date"}
                format={CONSTANT.POST_DATE_FORMAT}
                disabledDate={disabledDate}
                defaultValue={dayjs(new Date())}
                initialValue={dayjs(new Date())}
                onChange={handleChange}
                rules={[{ required: true, message: "Please Select Date." }]}
              />
            </Col>
          ) : null}
          {typeAction === "weekly" ? (
            <Col xs={24} md={8}>
              <InputBox.DatePicker
                required
                label="Select Date"
                name={"report_date"}
                placeholder={"Select Date"}
                format={CONSTANT.POST_DATE_FORMAT}
                disabledDate={disabledDate}
                defaultValue={dayjs(new Date())}
                initialValue={dayjs(new Date())}
                onChange={handleChange}
                rules={[{ required: true, message: "Please Select Date." }]}
              />
            </Col>
          ) : null}
          {typeAction === "quartely" ? (
            <Col xs={24} md={8}>
              <InputBox.DatePicker
                required
                label="Select Date"
                name={"report_date"}
                placeholder={"Select Date"}
                format={CONSTANT.POST_DATE_FORMAT}
                disabledDate={disabledDate}
                defaultValue={dayjs(new Date())}
                initialValue={dayjs(new Date())}
                onChange={handleChange}
                rules={[{ required: true, message: "Please Select Date." }]}
              />
            </Col>
          ) : null}
          {typeAction === "yearly" ? (
            <Col xs={24} md={8}>
              <InputBox.DatePicker
                required
                label="Select Year"
                name={"report_year"}
                rules={[{ required: true, message: "Please Select Year." }]}
                disabledDate={disabledDateForYear}
                onChange={handleChange}
                format={"YYYY"}
                picker="year"
              />
            </Col>
          ) : null}
          <Col xs={24} md={8}>
            <InputBox.Select
              label="Provider Code"
              name={"provider"}
              allowClear
              showSearch
              placeholder="Select Provider Code"
              tooltip="Select on from provided network provider list"
              onFocus={() => (providerListCode?.length > 0 ? null : updateProviderListCode())}
              notFoundContent={providerListCode?.length > 0 ? null : <Spin />}
              options={{
                list: providerListCode && providerListCode,
                valueKey: "id",
                textKey: "provider_code",
              }}
              onSelect={() => {
                if (typeAction === "monthly") {
                  setMonthReq(true);
                  handleChange();
                }
              }}
              onClear={() => {
                if (typeAction === "monthly") {
                  setMonthReq(false);
                  handleChange();
                }
              }}
              // required
              // rules={[validations.required.text('Provider')]}
            />
          </Col>
        </Row>
        <Row gutter={[20, 20]} className="mt-20">
          <Col xs={12} md={12} lg={6}>
            <Button type="primary" htmlType="submit" loading={loading}>
              <SVGIcon icon="add" color="#fff" width={55} /> Add Report
            </Button>
          </Col>
          <Col xs={12} md={12} lg={6}>
            <Button
              type="default"
              onClick={() => {
                form.resetFields();
                if (typeAction === "daily") {
                  form.setFieldsValue({ report_date: dayjs(new Date()) });
                }
              }}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </FormBox>
    </Modal>
  );
};

export default AddReport;
